import { render, staticRenderFns } from "./OlTextField.vue?vue&type=template&id=2dd39824&"
import script from "./OlTextField.vue?vue&type=script&lang=js&"
export * from "./OlTextField.vue?vue&type=script&lang=js&"
import style0 from "./OlTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
